import {DeepPartial} from 'utility-types';

import {GetDirectSaleVariantResponse} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../types/WarehouseDirectSaleVariantsDetailFormSchema';

type ReportingDefaultValues = NonNullable<
  DeepPartial<WarehouseDirectSaleVariantsDetailFormSchemaType>['reporting']
>;

export function buildReportingDefaultValues(
  reporting: GetDirectSaleVariantResponse['reporting'] | Nullish
): ReportingDefaultValues {
  return {
    ...reporting,
    excludedServiceOrderGroupIds: reporting?.excludedServiceOrderGroupIds ?? [],
    isDefaultServiceOrderGroupLocked: reporting?.isDefaultServiceOrderGroupLocked ?? false,
    isPreDeliveryInspection: reporting?.isPreDeliveryInspection ?? false,
  };
}
